// Copyright ©️ 2025 eVolve MEP, LLC

import React from 'react';

import type { TaskStatusTypeName } from '@evolvemep/api-ts';

import { EvolveIcon } from 'assets/icons/EvolveIcon';
import { AgGridStyleTooltip } from 'components/Mantine/AgGridStyleTooltip';

export const TaskPlayPauseIcon = ({
  taskStatusTypeName,
  spanProps,
}: {
  taskStatusTypeName: TaskStatusTypeName;
  spanProps?: React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>;
}) =>
  taskStatusTypeName === 'Started' || taskStatusTypeName === 'Paused' ? (
    <AgGridStyleTooltip
      openDelay={100}
      label={taskStatusTypeName === 'Started' ? 'Task is running' : 'Task is paused'}
      withArrow
    >
      <EvolveIcon spanProps={spanProps} icon={taskStatusTypeName === 'Started' ? 'Play' : 'Pause'} size="sm" inline />
    </AgGridStyleTooltip>
  ) : null;
